export default {
	FETCH_SAVED_WIDGETS: {
		method: 'GET',
		url: '/apps/pagewidget/template'
	},
	SUBMIT_SIGNUP_FORM: {
		method: 'POST',
		url: '/apps/pagewidget/entry'
	}
};



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/public/constants/endpoints.js